import { AddressDetails } from '@porterin/component-library/src/composite-components/google-auto-complete/GoogleAutoComplete';
const getInitialAddressDetails = (): AddressDetails => ({
  primaryAddress: {
    landmark: '',
    location: { lat: 0.0, lng: 0.0 },
  },
  postalAddress: {
    pincode: undefined,
    state: undefined,
    city: undefined,
    locality: undefined,
    sub_locality: undefined,
  },
});

const convertPlaceToAddressDetails = (
  place: google.maps.places.PlaceResult,
): AddressDetails => {
  const addressDetails: AddressDetails = getInitialAddressDetails();

  addressDetails.primaryAddress.landmark = place.formatted_address ?? '';
  if (place.geometry?.location) {
    addressDetails.primaryAddress.location = {
      lat: parseFloat(place.geometry.location.lat().toFixed(6)),
      lng: parseFloat(place.geometry.location.lng().toFixed(6)),
    };
  }

  place.address_components?.forEach(component => {
    const types = component.types;

    if (types.includes('postal_code')) {
      addressDetails.postalAddress.pincode = component.long_name;
    }
    if (types.includes('administrative_area_level_1')) {
      addressDetails.postalAddress.state = component.long_name;
    }
    if (types.includes('locality')) {
      addressDetails.postalAddress.city = component.long_name;
    }
    if (types.includes('route') || types.includes('neighborhood')) {
      addressDetails.postalAddress.locality = component.long_name;
    }
    if (types.includes('sublocality_level_1')) {
      addressDetails.postalAddress.sub_locality = component.long_name;
    }
  });

  return addressDetails;
};

export { getInitialAddressDetails, convertPlaceToAddressDetails };
